<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-primary">
            </div>
        </section>
        <section class="section pt-5 pb-5">
            <div class="container container-lg">
                <div class="row">
                    <div class="col-lg-4">
                        <profile-navigation :name="firstName"></profile-navigation>
                    </div>
                    <div class="col-lg-8">
                        <div class="d-md-flex justify-content-between align-items-center">
                            <h4>Meus Endereços</h4>
                            <base-button type="primary" class="mb-3" @click="$router.push('/perfil/enderecos/novo')">
                                <i class="fa fa-home mr-1"></i>
                                Novo Endereço
                            </base-button>
                        </div>
                        <v-wait for="profile.load.addresses"> 
                            <template slot="waiting">
                                <div class="ph-container">
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:80px"></div>
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:80px"></div>
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:80px"></div>
                                </div>
                            </template>
                            <p class="lead" v-if="!enderecos.length">
                              Não há endereços cadastrados.
                            </p>
                            <div v-else>
                            <card class="mb-4" shadow no-body v-for="endereco in enderecos" :key="endereco.id">
                                <div class="px-4 py-4">
                                    <div class="d-md-flex justify-content-between align-items-center address-line">
                                        <p><strong>{{endereco.nome}}</strong><br>
                                        {{endereco.endereco}}, {{endereco.numero}}<br>
                                        {{ !endereco.complemento ? '' : endereco.complemento+' - ' }}{{ !endereco.bairro ? '' : endereco.bairro+' - ' }}{{endereco.cidade}}, {{endereco.uf}}<br>
                                        CEP: {{endereco.cep}}</p>
                                        <p class="text-right">
                                            <base-button type="danger" @click="removeAddress(endereco.id)" title="remover" class="my-2 w-auto" size="sm">
                                                <i class="fa fa-trash"></i>
                                            </base-button>
                                            <router-link :to="{ name: 'user-profile-address-put', params: { id: endereco.id }}" class="btn btn-secondary btn-sm my-2 w-auto"><i class="fa fa-pencil"></i></router-link>
                                        </p>
                                    </div>
                                </div>
                            </card>
                            </div>
                        </v-wait>
                    </div>
                </div>
            </div>
        </section>
        <SlideYUpTransition :duration="500">
            <div class="modal fade"
                 @click.self="toggleAddressModalState"
                 :class="[{'show d-block': addressModal.show}, {'d-none': !addressModal.show}]"
                 v-show="addressModal.show"
                 tabindex="-1"
                 role="dialog"
                 :aria-hidden="!addressModal.show">

              <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content">
                  <div class="modal-body p-0">
                    <card type="secondary" shadow
                        header-classes="bg-white pb-5"
                        body-classes="px-lg-5 py-lg-5"
                        class="border-0">
                        <template>
                            <h5 class="mb-3 text-center">{{addressModalTitle}}</h5>
                        </template>
                        <template>
                            <form role="form" @submit.prevent method="get" :disabled="$wait.is('profile.add.address')">
                            <div class="row">
                                <div class="col-12">
                                    <base-input alternative
                                        class="mb-3"
                                        id="nome"
                                        :valid="formerrors.nome"
                                        v-model="newAddress.nome"
                                        placeholder="Dê um nome para o Endereço (ex.: casa, escritório)"
                                        >
                                    </base-input>
                                    <base-input alternative
                                        class="mb-3"
                                        id="cep"
                                        type="tel"
                                        required
                                        pattern="[0-9]{5}-[0-9]{3}"
                                        v-model="newAddress.cep"
                                        placeholder="CEP"
                                        :valid="formerrors.cep"
                                        v-mask="'#####-###'"
                                        >
                                    </base-input>
                                    <base-input alternative
                                        class="mb-3"
                                        id="endereco"
                                        v-model="newAddress.endereco"
                                        placeholder="Logradouro"
                                        :valid="formerrors.endereco"
                                        >
                                    </base-input>
                                </div>
                                <div class="col-6">
                                    <base-input alternative
                                        class="mb-3"
                                        type="tel"
                                        pattern="[0-9]{1,}"
                                        id="numero"
                                        v-model="newAddress.numero"
                                        placeholder="Número"
                                        :valid="formerrors.numero"
                                        >
                                    </base-input>
                                </div>
                                <div class="col-6">
                                    <base-input alternative
                                        class="mb-3"
                                        id="complemento"
                                        v-model="newAddress.complemento"
                                        placeholder="Complemento"
                                        >
                                    </base-input>
                                </div>
                                <div class="col-12">
                                    <base-input alternative
                                        class="mb-3"
                                        id="bairro"
                                        v-model="newAddress.bairro"
                                        placeholder="Bairro"
                                        >
                                    </base-input>
                                    <base-input alternative
                                        class="mb-3"
                                        id="cidade"
                                        v-model="newAddress.cidade"
                                        placeholder="Cidade"
                                        :valid="formerrors.cidade"
                                        >
                                    </base-input>
                                    <v-select
                                        class="form-group input-group-alternative mt-3"
                                        :class="{'error': formerrors.uf == false}"
                                        v-on:input="newAddress.uf = $event"
                                        :value="newAddress.uf"
                                        :key="newAddress.uf"
                                        placeholder="Estado"
                                        :options="estados"
                                        :reduce="estado => estado.code"
                                        />
                                    <base-input alternative
                                        class="mb-3"
                                        id="ponto_referencia"
                                        v-model="newAddress.ponto_referencia"
                                        placeholder="Ponto de Referência"
                                        >
                                    </base-input>
                                </div>
                                <div class="col-12">
                                    <base-button type="primary" @click="toggleAddressModalState" class="mt-4 d-inline-block float-left">Voltar</base-button>
                                    <base-button nativeType="submit" @click="putAddress()" type="success" class="mt-4 d-inline-block float-right">{{addressModalButton}}</base-button>
                                </div>
                            </div>
                            </form>
                        </template>
                    </card>
                  </div>
                </div>
              </div>
            </div>
        </SlideYUpTransition>
        <modal :show.sync="removeConfirm.show"
               modal-classes="modal-danger modal-dialog-centered">
            <h6 slot="header" class="modal-title" id="modal-title-notification">Excluir endereço</h6>

            <div class="py-3 text-center">
                <i class="fa fa-home fa-4"></i>
                <p>Tem certeza que deseja remover esse endereço?</p>
            </div>

            <template slot="footer">
                <base-button type="white" @click="excludeAddress(removeConfirm.pk)">Remover</base-button>
                <base-button type="link"
                             text-color="white"
                             class="ml-auto"
                             @click="removeConfirm.show = false">
                    Cancelar
                </base-button>
            </template>
        </modal>
    </div>
</template>
<script>
import { SlideYUpTransition } from "vue2-transitions";

import vSelect from 'vue-select';

import ProfileNavigation from './components/ProfileNavigation.vue';

import EstadosBrasileiros from '@/settings/estados.json';

import {mask} from 'vue-the-mask';

import Modal from "@/components/Modal.vue";

export default {
	name: 'profile-address',
    directives: {mask},
    components: {
        ProfileNavigation,
        SlideYUpTransition,
        vSelect,
        Modal,
    },
    data() {
    return {
      modal: {
        title: 'Falha na Solicitação!',
        body: 'Por favor, tente novamente mais tarde',
        classe: 'modal-danger',
        icon: 'ni ni-basket', 
        okButton: 'OK',
      },
      removeConfirm: {
        show: false,
        pk: null
      },
      addressModal: {
        show: false
      },
      newAddress: {},
      formerrors: {},
      enderecos: [],
      estados: EstadosBrasileiros,
      };
    },
    computed: {
        firstName: function() {
            return this.$store.state.auth.first_name
        },
        addressModalTitle: function() {
            return ( !this.newAddress.id ) ? 'Novo Endereço' : 'Editar Endereço';
        },
        addressModalButton: function() {
            return ( !this.newAddress.id ) ? 'Cadastrar' : 'Salvar';
        },
    },
    methods: {
        findByID(id){
            return this.enderecos.filter(endereco => 
            endereco.id == id )[0];
        },
        removeAddress(id){
            this.removeConfirm.pk = id;
            this.removeConfirm.show = true;
        },
        excludeAddress(id){
            this.axios.delete('/v1/address/'+id+'/').then(response => {
                let refresh = this.enderecos.filter(endereco => 
                endereco.id !== id );
                this.enderecos = refresh;
                this.removeConfirm.show = false;
            });
        },
        toggleAddressModalState(){
            this.addressModal.show = !this.addressModal.show;
        },
        emptyAddress(){
            this.newAddress = {};
            this.formerrors = {};
            this.toggleAddressModalState();
        },
        editAddress(id) {
            const addressEdit = this.findByID(id);
            this.newAddress = addressEdit;
            this.formerrors = {};
            this.toggleAddressModalState();
        },
        putAddress(){
            const payload = this.newAddress;
            this.formerrors = {};
            this.$wait.start('profile.post.address');
            if ( payload.id ) {
                let _id = payload.id;
                this.axios.patch('/v1/address/'+_id+'/', payload)
                .then(response => {
                  // não precisa fazer nada, já que o Vue é reativo.
                  this.addressModal.show = false;
                })
                .catch(e => {
                  let errors = e.data;
                  Object.keys(errors).forEach(key => {
                    this.formerrors[key] = false;
                  });
                }).then(response =>{
                    this.$wait.end('profile.post.address');
                });
            } else {
                this.axios.post('/v1/address/', payload)
                .then(response => {
                  // find by id
                  let addedAddress = response.data;
                  this.enderecos.push(addedAddress);
                  this.newAddress = {};
                  this.addressModal.show = false;
                })
                .catch(e => {
                  let errors = e.data;
                  Object.keys(errors).forEach(key => {
                    this.formerrors[key] = false;
                  });
                }).then(response =>{
                    this.$wait.end('profile.post.address');
                });
            }
        },
    },
    created() {
        if ( !this.enderecos.length ) {
            this.$wait.start('profile.load.addresses');
            this.axios.get('/v1/address/')
            .then(response => {
              this.enderecos = response.data;
              this.$wait.end('profile.load.addresses');
            });
        }
        //
    }
};
</script>

<style lang="scss">
    .address-line {
        p {
            margin-bottom: 0;
            font-size: 0.9em;
            line-height: 1.4;
            strong {
                font-weight: 700;
            }
        }
    } 
</style>
